const PERMANANT_FLAGS = {
    clientSideTracing: {
        key: 'client-side-tracing',
        value: false
    }
};
const DEMO_FLAGS = {};
const ENTITLEMENT_FLAGS = {
    chronosphereUniversityLinkEnabled: {
        key: 'chronosphere-university-link-enabled',
        value: false
    },
    docsSiteMode: {
        key: 'docs-site-mode',
        value: 'disabled'
    },
    enableSCIM: {
        key: 'enable-scim',
        value: false
    },
    enableTimelineUI: {
        key: 'enable-timeline-ui',
        value: false
    },
    loggingUI: {
        key: 'logging-ui',
        value: false
    },
    logscaleEnabled: {
        key: 'logscale-enabled',
        value: false
    },
    enableAlertBacktesting: {
        key: 'enable-alert-backtesting',
        value: false
    },
    enableAlertBacktestingUI: {
        key: 'enable-alert-backtesting-ui',
        value: false
    }
};
const GLOBAL_FEATURE_FLAGS = {
    enableRemoveContainerOverflow: {
        key: 'enable-remove-container-overflow',
        value: false
    },
    uiHeartbeatCheckIntervalSeconds: {
        key: 'ui-hearbeat-check-interval-seconds',
        value: 0
    }
};
const SERVICE_WIDGET_FLAGS = {
    showServiceInfoWidget: {
        key: 'show-service-info-widget',
        value: false
    }
};
const SERVICE_FLAGS = {
    serviceConfigv2: {
        key: 'service-config-v2',
        value: false
    },
    metricsExplorerPinnedScopeEnabled: {
        key: 'pinned-scope.native-metrics-explorer',
        value: 'disabled'
    },
    metricsDdxPoc: {
        key: 'metrics-ddx-poc',
        value: false
    },
    enableXrayPreview: {
        key: 'enable-xray-preview',
        value: false
    }
};
const AGG_RULES_FLAGS = {
    aggRulesRework: {
        key: 'agg-rules-rework',
        value: false
    }
};
const METRICS_ANALYZER_FLAGS = {
    uiMetricsAnalyzerIngestionSamplingRate: {
        key: 'ui-metrics-analyzer-ingestion-sampling-rate',
        value: 100
    }
};
const METRICS_USAGE_FLAGS = {
    usageDetailsExecutionTruncationUI: {
        key: 'usage-details-execution-truncation-ui',
        value: false
    }
};
const METRICS_ALLOCATION_FLAGS = {
    metricsQuotasRework: {
        key: 'metrics-quotas-rework',
        value: false
    },
    disableQuotaConfiguration: {
        key: 'disable-quota-configuration',
        value: false
    }
};
const CONSUMPTION_BASED_PRICING_FLAGS = {
    enableUiConsumptionDatasource: {
        key: 'enable-ui-consumption-datasource',
        value: false
    },
    enableLogsConsumptionUI: {
        key: 'enable-logs-consumption-ui',
        value: false
    },
    enableMetricsConsumptionUI: {
        key: 'enable-metrics-consumption-ui',
        value: false
    },
    tracingConsumptionPricing: {
        key: 'tracing-consumption-pricing',
        value: false
    },
    tracingConsumptionLicenseContractEpoch: {
        key: 'tracing-consumption-license-contract-epoch',
        value: 0
    }
};
const LICENSE_OVERVIEW_FLAGS = {
    enableLicenseOverview: {
        key: 'enable-license-overview',
        value: false
    },
    enableLicenseOverviewAdminHomepage: {
        key: 'enable-license-overview-admin-homepage',
        value: false
    }
};
const RECOMMENDATIONS_FLAGS = {
    enableControlRecommendationsUI: {
        key: 'enable-control-recommendations-ui',
        value: false
    }
};
const MONITORS_FLAGS = {
    enableNotificationRoutesGroupBy: {
        key: 'enable-notification-routes-group-by',
        value: false
    },
    logscaleDatasourceEnabled: {
        key: 'logscale-datasource-enabled',
        value: false
    },
    enableSeriesLabelRouting: {
        key: 'enable-series-label-routing',
        value: false
    },
    monitorEntityLayoutUpdateUi: {
        key: 'monitor-entity-layout-update-ui',
        value: false
    },
    enableLegacyTimelineEventPresets: {
        key: 'enable-legacy-timeline-event-presets',
        value: false
    }
};
const ALERTING_FLAGS = {
    enableAlertsResolutionNotes: {
        key: 'enable-alerts-resolution-notes',
        value: false
    }
};
const MUTING_RULES_FLAGS = {
    enableMutingrulesEnhancementsUI: {
        key: 'enable-mutingrules-enhancements-ui',
        value: false
    },
    enableDdxSuggestions: {
        key: 'enable-ddx-suggestions',
        value: false
    }
};
const DEV_ERGO_FLAGS = {
    devErgoHomepageMostViewed: {
        key: 'dev-ergo-home-trending',
        value: false
    },
    devErgoHomeActivityFeed: {
        key: 'dev-ergo-home-activity-feed',
        value: false
    },
    enableEntityPopularityUi: {
        key: 'enable-entity-popularity-ui',
        value: false
    },
    devErgoTriageMapRefactor: {
        key: 'dev-ergo-triage-map-perf-boost',
        value: false
    },
    enableVersionHistoryAiExplanation: {
        key: 'enable-version-history-ai-explanation',
        value: false
    },
    devErgoPanelLayout: {
        key: 'dev-ergo-panel-layout',
        value: false
    },
    devErgoPanelGroupBuilder: {
        key: 'dev-ergo-panel-group-builder',
        value: false
    },
    enableDataQueriesLoadingCacheCheck: {
        key: 'enable-data-queries-loading-cache-check',
        value: false
    },
    devErgoStatusHistory: {
        key: 'dev-ergo-status-history',
        value: false
    },
    enableTimeSeriesChartDeclutterCommonLabels: {
        key: 'enable-time-series-chart-declutter-common-labels',
        value: false
    },
    enableHeatmapPanelEvents: {
        key: 'enable-heatmap-panel-events',
        value: false
    }
};
const DASHBOARDING_FLAGS = {
    enableDefaultNativeDashboardPreview: {
        key: 'enable-default-native-dashboard-preview',
        value: false
    },
    enableDashboardCompareMode: {
        key: 'enable-dashboard-compare-mode',
        value: false
    },
    enableNativeDashboards: {
        key: 'enable-native-dashboards',
        value: 'disabled'
    },
    enableVizFrameworkFormulas: {
        key: 'enable-vf-formulas',
        value: false
    },
    nativeDashboardsDatapointsLimit: {
        key: 'native-dashboards-datapoints-limit',
        value: 400000
    },
    nativeDashboardsSeriesLimit: {
        key: 'native-dashboards-series-limit',
        value: 4000
    },
    showNativeDashboardPreview: {
        key: 'show-native-dashboard-preview',
        value: false
    },
    enableLoadClassicDashboardButton: {
        key: 'enable-load-classic-dashboard-button',
        value: true
    },
    enableNativeMetricsExplorerMode: {
        key: 'enable-native-metrics-explorer-mode',
        value: 'off'
    },
    enableNativeDashboardPinnedScopes: {
        key: 'pinned-scope.native-dashboards',
        value: false
    },
    maxDatapointsPerSeries: {
        key: 'max-datapoints-per-series',
        value: 1920
    },
    enableExperimentalResolutionControls: {
        key: 'enable-experimental-resolution-controls',
        value: false
    },
    enableNewVariableUx: {
        key: 'enable-new-variable-ux',
        value: false
    },
    enableFormatPromQL: {
        key: 'enable-format-promql',
        value: false
    },
    enablePromQLQueryBuilder: {
        key: 'enable-promql-query-builder',
        value: false
    },
    enablePersonalCollections: {
        key: 'enable-personal-collections',
        value: false
    },
    enableDashboardSavedViews: {
        key: 'enable-dashboard-saved-views',
        value: false
    },
    enableDashboardAnnotations: {
        key: 'enable-dashboard-annotations',
        value: false
    },
    enableDistributionChartPlugin: {
        key: 'enable-distribution-chart-plugin',
        value: false
    },
    enableAutoStackedBarTruncation: {
        key: 'enable-auto-stacked-bar-truncation',
        value: false
    },
    enableDashboardUndoNotification: {
        key: 'enable-dashboard-undo-notification',
        value: false
    },
    enableMutableDashboardAnnotations: {
        key: 'enable-mutable-dashboard-annotations',
        value: false
    }
};
const TRACING_FLAGS = {
    tracingTopologyViewEdges: {
        key: 'tracing-topology-view-edges',
        value: false
    },
    tracingDdxSampleCount: {
        key: 'tracing-ddx-sample-count',
        value: 16
    },
    tracingSystemLimitMetric: {
        key: 'tracing-system-limit-metric',
        value: 'off'
    },
    tracingTagPartitionConcurrency: {
        key: 'tracing-tag-query-partition-concurrency',
        value: 1
    }
};
const IMPACT_FLAGS = {
    derivedLabelsCrud: {
        key: 'derived-labels-crud',
        value: false
    },
    enableRelatedAlertsSummaryViz: {
        key: 'enable-related-alerts-summary-viz',
        value: false
    },
    impactAnalyzeAlertsOnAlertsPage: {
        key: 'impact-analyze-alerts-on-alerts-page',
        value: false
    },
    alertAnalysisMaxTimeRangeDuration: {
        key: 'alert-analysis-max-time-range-duration',
        value: 3600
    },
    impactAtMentions: {
        key: 'impact-at-mentions',
        value: false
    },
    impactHomeCustomization: {
        key: 'impact-home-customization',
        value: false
    }
};
const TIMELINE_FLAGS = {
    timelineEnableRecentFilters: {
        key: 'enable-recent-filters',
        value: false
    },
    timelineEnableSavedFilters: {
        key: 'enable-saved-filters',
        value: false
    },
    timelineEnableSharedFilters: {
        key: 'enable-shared-filters',
        value: false
    },
    timelineEnableLabelColumns: {
        key: 'enable-event-label-columns',
        value: true
    }
};
const LOGGING_FLAGS = {
    loggingInternalNavEnabled: {
        key: 'logging-internal-nav-enabled',
        value: false
    },
    loggingEnableLoggingDashboardDatasource: {
        key: 'enable-logging-dashboard-datasource',
        value: false
    },
    loggingEnableProgressiveDatasource: {
        key: 'logging-enable-progressive-datasource',
        value: false
    },
    loggingEnableUsageAnalysis: {
        key: 'enable-usage-analysis',
        value: false
    },
    loggingEnableLicenseOverview: {
        key: 'logging-enable-license-overview',
        value: false
    },
    loggingEnableLogPinning: {
        key: 'logging-enable-log-pinning',
        value: false
    },
    loggingEnableParsers: {
        key: 'logging-enable-parsers',
        value: false
    },
    loggingEnableControlRules: {
        key: 'logging-enable-control-rules',
        value: false
    },
    enableLoggingGrammarNext: {
        key: 'enable-logging-grammar-next',
        value: false
    },
    enableLogProcessedBytesLicenseDashboard: {
        key: 'enable-log-processed-bytes-license-dashboard',
        value: false
    },
    enableLogsLookupTables: {
        key: 'enable-logs-lookup-tables',
        value: false
    },
    enableAiLogSummary: {
        key: 'enable-ai-log-summary',
        value: false
    },
    enableFieldMappingsIngestConfigUi: {
        key: 'enable-field-mappings-ingest-config-ui',
        value: false
    }
};
const NATURAL_LANGUAGE_INTERFACE_FLAGS = {
    enableMetricsCatalogDrawer: {
        key: 'enable-metrics-catalog-drawer',
        value: false
    },
    aiDescriptionsEnabled: {
        key: "ai-descriptions-enabled-ui",
        value: false
    },
    aiPromQLQueryGeneration: {
        key: 'ai-promql-query-generation',
        value: false
    },
    aiChatUi: {
        key: 'ai-chat-ui',
        value: false
    },
    dashboardsEnableAiDescription: {
        key: "dashboards.enable-ai-description",
        value: false
    },
    enableAiLogsQueryGeneration: {
        key: 'enable-ai-logs-query-generation',
        value: false
    }
};
const SERVICE_ACCOUNT_FLAGS = {
    enableServiceTokenUsageCustomerUi: {
        key: 'enable-service-token-usage-customer-ui',
        value: false
    }
};
const VIZ_FRAMEWORK_FLAGS = {
    enableVizFrameworkMocks: {
        key: 'enable-viz-framework-mocks',
        value: false
    },
    enableTimeRangeProviderV2: {
        key: 'enable-time-range-provider-v2',
        value: false
    },
    enableNewDateTimePickerFormat: {
        key: 'enable-new-date-time-picker-format',
        value: false
    }
};
const DEVEX_FLAGS = {
    enableSidebar: {
        key: 'enable-sidebar',
        value: false
    }
};
const AI_KG_FLAGS = {
    showInferredAlertEvents: {
        key: 'inferred-alert-events',
        value: false
    },
    metricExplorerAnomalies: {
        key: 'metric-explorer-anomalies',
        value: false
    },
    agentInvestigationsEnabled: {
        key: 'agent-investigations-enabled',
        value: false
    }
};
const EXPLORATION_FLAGS = {
    enableNotebooks: {
        key: 'enable-notebooks',
        value: false
    },
    enableNotebookInvestigations: {
        key: 'enable-notebook-investigations',
        value: false
    },
    enableNotebooksCrud: {
        key: 'enable-notebooks-crud',
        value: false
    }
};
const FEATURE_FLAG_CONFIG = {
    ...PERMANANT_FLAGS,
    ...DEMO_FLAGS,
    ...GLOBAL_FEATURE_FLAGS,
    ...ENTITLEMENT_FLAGS,
    ...ALERTING_FLAGS,
    ...SERVICE_WIDGET_FLAGS,
    ...SERVICE_FLAGS,
    ...METRICS_ANALYZER_FLAGS,
    ...METRICS_USAGE_FLAGS,
    ...METRICS_ALLOCATION_FLAGS,
    ...CONSUMPTION_BASED_PRICING_FLAGS,
    ...LICENSE_OVERVIEW_FLAGS,
    ...RECOMMENDATIONS_FLAGS,
    ...MONITORS_FLAGS,
    ...DEV_ERGO_FLAGS,
    ...DASHBOARDING_FLAGS,
    ...TRACING_FLAGS,
    ...TIMELINE_FLAGS,
    ...LOGGING_FLAGS,
    ...AGG_RULES_FLAGS,
    ...SERVICE_ACCOUNT_FLAGS,
    ...VIZ_FRAMEWORK_FLAGS,
    ...IMPACT_FLAGS,
    ...NATURAL_LANGUAGE_INTERFACE_FLAGS,
    ...MUTING_RULES_FLAGS,
    ...DEVEX_FLAGS,
    ...AI_KG_FLAGS,
    ...EXPLORATION_FLAGS
};
const LOCAL_FEATURE_FLAGS = {
    enableVizFrameworkSchemaValidation: false,
    shouldAutoMigrateGrafanaDashboard: false,
    enableDashboardSafeMode: false,
    truncationStrategyLimit: 150,
    enableCopyPanelAsJson: true,
    aiLogsQueryGeneration: false,
    aiToolsKnowledgeBuilderQueryEnabled: false
};
const isLocalFeatureFlag = (flag)=>flag in LOCAL_FEATURE_FLAGS;
export { FEATURE_FLAG_CONFIG, LOCAL_FEATURE_FLAGS, isLocalFeatureFlag };

//# sourceMappingURL=feature-flags-helper.js.map